import React from 'react'
import { Link } from 'react-router-dom'


const PageNotFound = () => {
 
  return (
    <div className='page_not_found'>
        <h1 className='text-center'>404</h1>
        <p>Page not found</p>
        <Link to={'dashboard'} className='btn btn-primary'>Return to Dashboard</Link>
    </div>
  )
}

export default PageNotFound